define('views/pages/account/AccountView',['underscore','backbone','SubView'],
    function (_,Backbone,SubView) {

    //
    // Account View
    // abstraction pour les sous-pages de mon compte
    //

    return Backbone.View.extend(SubView).extend({
        initialize:function(){
            var view = this;
            view.subviews = [];
            Backbone.View.prototype.initialize.apply(view,arguments);
        },
        afterInitialize:function(){}
    });
});
